// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information {
  font-size: 20px;
  font-weight: bold;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.d-col {
  display: flex;
  flex-direction: column;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-end {
  justify-content: flex-end;
}

h2 {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/forgot-password-init-flow/forgot-password-init-flow.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":[".information {\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.justify-content-end {\n    justify-content: flex-end;\n}\n\nh2 {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
